// extracted by mini-css-extract-plugin
export default {"cls1":"Lm9Aj3LpU0uXCrwPr5iv","cls2":"BcaFXQxjKOhBvGK2lrGh Lm9Aj3LpU0uXCrwPr5iv"};